import { useState } from "react";
import axios from "axios";
import {
    FaEnvelope,
    FaPhoneAlt,
    FaGlobe,
    FaTwitter,
    FaLinkedin,
    FaGithub,
    FaYoutube
} from "react-icons/fa";

export default function Contact() {
    const [form, setForm] = useState({
        name: "",
        email: "",
        message: ""
    });
    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("Sending...");

        try {
            const res = await axios.post("http://localhost:8000/contact", form);
            setStatus(res.data.message);
            setForm({ name: "", email: "", message: "" });
        } catch (err) {
            setStatus("Something went wrong. Please try again later.");
        }
    };

    return (
        <div className="w-full  bg-white">
            <div className="max-w-6xl mx-auto px-6 py-14">

                {/* HEADER */}
                <div className="mb-12">
                    <h1 className="text-3xl font-semibold text-gray-900">
                        Contact Tech Article Hub
                    </h1>
                    <p className="mt-2 text-gray-600 max-w-xl">
                        Questions, feedback, or business inquiries?
                        We’d love to hear from you.
                    </p>
                </div>

                {/* GRID */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12">

                    {/* FORM */}
                    <form
                        onSubmit={handleSubmit}
                        className="border border-gray-200 rounded-lg p-6 space-y-5"
                    >
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Your Name
                            </label>
                            <input
                                type="text"
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Email Address
                            </label>
                            <input
                                type="email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Message
                            </label>
                            <textarea
                                rows="4"
                                name="message"
                                value={form.message}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                            />
                        </div>

                        <button
                            type="submit"
                            className="bg-black text-white px-6 py-2 rounded-md hover:bg-gray-800 transition"
                        >
                            Submit Message
                        </button>

                        {status && (
                            <p className="text-sm text-gray-600 mt-2">
                                {status}
                            </p>
                        )}
                    </form>

                    {/* CONTACT DETAILS */}
                    <div className="space-y-6">
                        <div>
                            <h2 className="text-xl font-semibold text-gray-900">
                                Tech Article Hub
                            </h2>
                            <p className="text-gray-600">
                                A global platform for tech news, AI updates, and easy-to-read articles.
                            </p>
                        </div>

                        <div className="flex items-start gap-3 text-gray-700">
                            <FaEnvelope />
                            <span>contact@techarticlehub.com</span>
                        </div>

                        <div className="flex items-start gap-3 text-gray-700">
                            <FaPhoneAlt />
                            <span>+1 000 000 0000</span>
                        </div>

                        <div className="flex items-start gap-3 text-gray-700">
                            <FaGlobe />
                            <span>https://techarticlehub.com</span>
                        </div>

                        {/* SOCIAL */}
                        <div>
                            <p className="font-medium text-gray-900 mb-3">
                                Follow Us
                            </p>

                            <div className="flex gap-6 text-3xl">
                                <a
                                    href="https://x.com/techarticlehub"
                                    aria-label="Twitter"
                                    className="text-[#1DA1F2] hover:opacity-80 transition"
                                >
                                    <FaTwitter />
                                </a>

                                <a
                                    href="https://www.linkedin.com/in/naveen-kumar-gupta91/"
                                    aria-label="LinkedIn"
                                    className="text-[#0A66C2] hover:opacity-80 transition"
                                >
                                    <FaLinkedin />
                                </a>

                                <a
                                    href="#"
                                    aria-label="GitHub"
                                    className="text-gray-900 hover:text-black transition"
                                >
                                    <FaGithub />
                                </a>

                                <a
                                    href="https://www.youtube.com/@PythonCodebyNaveen"
                                    aria-label="YouTube"
                                    className="text-[#FF0000] hover:opacity-80 transition"
                                >
                                    <FaYoutube />
                                </a>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    );
}
